import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  position: sticky;
  padding: 24px;
  background-color: white;
  border-radius: 12px;
  transition: top 0.3s ease;
  top: 24px;
  .ant-collapse-arrow {
    right: 0;
  }
  .ant-collapse-icon-position-right
    > .ant-collapse-item
    > .ant-collapse-header {
    padding: 12px 0;
  }
  .ant-collapse-item {
    :not(:last-child) {
      padding-bottom: 12px;
      border-bottom: 1px solid ${color.grey1};
    }
    :not(:first-child) {
      padding-top: 12px;
    }
    > .ant-collapse-header .ant-collapse-arrow {
      right: 0;
      color: ${color.black4};
    }
  }
  .ant-collapse-content > .ant-collapse-content-box {
    padding: 0;
  }
  .component_header_menu {
    display: flex;
    column-gap: 12px;
    align-items: center;
    color: ${color.black2};
    .anticon {
      font-size: 20px;
    }
    &.active {
      color: ${color.green1};
    }
  }

  .component_sub_menu {
    padding: 12px 16px;
    border-radius: 12px;
    cursor: pointer;
    position: relative;
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .anticon {
        font-size: 20px;
        color: ${color.black3};
      }
    }
    :not(:last-child) {
      margin-bottom: 16px;
    }
    &.active {
      background-color: ${color.green6};
    }
    &.with_icon {
      margin-top: 40px;
      ::before {
        content: '';
        height: 1px;
        width: 100%;
        display: block;
        position: absolute;
        top: -20px;
        left: 0;
        background-color: ${color.grey1};
      }
    }
  }
`;

export default Wrapper;
